import { StatesModule, Transition } from '@uirouter/angular';
import { ChatComponent } from './components/chat/chat.component';
import { UserStateService } from '../auth/services/user-state.service';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps.chat',
      url: '/chat',
      component: ChatComponent,
      resolve: [{
        token: 'canAccessAps',
        deps: [Transition, UserStateService],
        resolveFn: (transition: Transition, userState: UserStateService) => {
          if (!userState.isRiseAdmin()) {
            console.log('User is not an admin, redirecting to home');
            transition.abort();
            return transition.router.stateService.go('apps.home');
          }
        }
      }]
    }
  ]
};
